import { useCallback } from 'react';
import { Node, useReactFlow } from 'reactflow';

interface NodeData {
    [key: string]: any;
}

const useReactFlowHelpers = () => {
    const { getNodes, getNode, setNodes, getEdges } = useReactFlow();

    const updateRequestNodeData = useCallback(
        // (newData: NodeData) => {
        //     setNodes((nodes) =>
        //         nodes.map((node) =>
        //             node.type === 'requestNode'
        //                 ? { ...node, data: { ...node.data, ...newData } }
        //                 : node
        //         )
        //     );
        // },
        (newData: NodeData) => {
            let updatedNodeData: NodeData = {};

            setNodes((nodes) => {
                console.log('nodes while updateing: ', nodes)
                return nodes.map((node) => {
                    let updatedNode = node;
                    if (node.type === 'requestNode') {
                        updatedNode = { ...node, data: { ...node.data, ...newData } }
                        console.log('updating request node: ', updatedNode);
                        updatedNodeData = updatedNode.data;
                    }

                    return updatedNode;
                })
            });

            return updatedNodeData;
        }, [setNodes]);

    const getRequestNodeSchema = useCallback(() => {
        const nodes = getNodes();
        const requestNode = nodes.find((node) => node.type === 'requestNode');

        console.log('returning request schema from node: ', requestNode)
        return requestNode?.data?.request_schema || {};
    }, [getNodes]);

    const getParentNode = useCallback((currNodeId: string): Node | null => {
        const edges = getEdges();
        const parentEdge = edges.find(edge => edge.target === currNodeId)
        if (!parentEdge) return null;

        const parentNode = getNode(parentEdge.source)

        return parentNode || null;
    }, [getEdges, getNode])


    return { updateRequestNodeData, getRequestNodeSchema, getParentNode };
};

export default useReactFlowHelpers;
